import { Grid } from '@mui/material';
import React, { useState } from 'react';
import styles from './ReviewContent.module.scss';
import EditIcon from '@mui/icons-material/Edit';
import PurchaserInformation from './PurchaserInformation/PurchaserInformation';
import ProductInformation from './ProductInformation/ProductInformation';
import Pricing from './Pricing/Pricing';
import Reviewheader from '../ReviewHeader/ReviewHeader';
import { goToStep } from '../../../../redux/agreement/actions';
import { connect } from 'react-redux';
import { closeModal } from '../../../../redux/modals/action';

const ReviewContent = ({
	viewOnly,
	goToStep,
	closeModal,
	editMode,
	setEditMode,
	purchaserInformation,
	setPurchaserInformation,
	tabSelected,
	setTabSelected,
	depositScheduleData,
	setDepositScheduleData,
	saveEditOnPrice,
	setSaveEditOnPrice,
	error,
	setError,
}) => {
	const handleSelectTab = (tabId) => {
		setTabSelected(tabId);
		setEditMode(false);
	};

	const handleEdit = () => {
		if (tabSelected === 0 || tabSelected === 2) {
			setEditMode(true);
		} else if (tabSelected === 1) {
			closeModal('reviewAps');
			goToStep(1);
		}
	};

	return (
		<>
			<div className={styles.review_content_wrapper}>
				<Grid
					container
					className={styles.tabular_top}
					justifyContent='space-between'
				>
					<Grid item className={styles.tab_container}>
						<div
							className={`${styles.tab_item} ${
								tabSelected === 0 && styles.active
							}`}
							onClick={() => handleSelectTab(0)}
						>
							Purchaser information
						</div>
						<div
							className={`${styles.tab_item} ${
								tabSelected === 1 && styles.active
							}`}
							onClick={() => handleSelectTab(1)}
						>
							Product information
						</div>
						<div
							className={`${styles.tab_item} ${
								tabSelected === 2 && styles.active
							}`}
							onClick={() => handleSelectTab(2)}
						>
							Pricing
						</div>
					</Grid>
					{!editMode && viewOnly === false && (
						<Grid item>
							<div className={styles.edit_button}>
								<div className={styles.edit_icon}>
									<EditIcon />
								</div>
								<div
									className={styles.text_btn}
									onClick={handleEdit}
								>
									Edit Mode
								</div>
							</div>
						</Grid>
					)}
				</Grid>
				<hr className={styles.separator} />

				<div className={styles.main_content}>
					{tabSelected === 0 && (
						<PurchaserInformation
							editMode={editMode}
							purchaserInformation={purchaserInformation}
							setPurchaserInformation={setPurchaserInformation}
							error={error}
							setError={setError}
						/>
					)}
					{tabSelected === 1 && <ProductInformation />}
					{tabSelected === 2 && (
						<Pricing
							editMode={editMode}
							depositScheduleData={depositScheduleData}
							setDepositScheduleData={setDepositScheduleData}
							saveEditOnPrice={saveEditOnPrice}
							setSaveEditOnPrice={setSaveEditOnPrice}
						/>
					)}
				</div>
			</div>
		</>
	);
};

export default connect(null, { goToStep, closeModal })(ReviewContent);
